export default __webpack_public_path__ + "static/media/gnl5.01a57133.jpg";